import Types from '../actions/Types';

const initialState = {
  bootMs: null
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case Types.STARTUP:
      return { bootMs: Date.now() };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/app.js